<template>
  <div class="copyright">
    <p>
      <span>
        网站备案：
        <a href="http://beian.miit.gov.cn/" target="_blank">
          鄂ICP备2024073121号
        </a>
      </span>
      <!-- <span>
        <img
          src="./images/national_emblem.png"
          alt=""
          style="vertical-align: middle"
        >
        公安备案号：42018502000182
      </span> -->
      <span>Copyright @ 2014 4sjob.com All Right Reserved</span>
    </p>
    <p>
      地址：武汉市东湖新技术开发区高新大道815号光谷国际人才港3楼（地铁11号线豹澥站C出口旁）
    </p>
    <p>未经同意，不得转载本网站之所有招聘信息及资讯信息</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.copyright {
  padding: 15px 0;
  font-size: 14px;
  color: #666;
  line-height: 32px;
  text-align: center;

  span {
    padding: 0 15px;
  }
  a {
    text-decoration: underline;
    color: #666;
    &:hover {
      color: #1492ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/copyright.vue